/** Max contest evidence photos — keep in sync with backend
 *  `normalizeAppealEvidenceImageUrls.MAX_APPEAL_EVIDENCE_IMAGES`. */
export const MAX_APPEAL_EVIDENCE_IMAGES = 5;
